/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeleteIntegrationRequest
 */
export interface DeleteIntegrationRequest {
  /**
   *
   * @type {string}
   * @memberof DeleteIntegrationRequest
   */
  integrationId: string;
}

/**
 * Check if a given object implements the DeleteIntegrationRequest interface.
 */
export function instanceOfDeleteIntegrationRequest(
  value: object,
): value is DeleteIntegrationRequest {
  if (!("integrationId" in value) || value["integrationId"] === undefined)
    return false;
  return true;
}

export function DeleteIntegrationRequestFromJSON(
  json: any,
): DeleteIntegrationRequest {
  return DeleteIntegrationRequestFromJSONTyped(json, false);
}

export function DeleteIntegrationRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DeleteIntegrationRequest {
  if (json == null) {
    return json;
  }
  return {
    integrationId: json["integrationId"],
  };
}

export function DeleteIntegrationRequestToJSON(
  json: any,
): DeleteIntegrationRequest {
  return DeleteIntegrationRequestToJSONTyped(json, false);
}

export function DeleteIntegrationRequestToJSONTyped(
  value?: DeleteIntegrationRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    integrationId: value["integrationId"],
  };
}
